/* The closing buy bar.
 *
 * It appears once the visitor has met a buy block and that block is no longer
 * on screen, and it hides again whenever one is. So it never covers a picker
 * with a picker, and it never shows before the page has made its offer once.
 *
 * It publishes its own height as --silt-buybar-h, which is what lifts the
 * docked mode toggle clear of it. Neither one hard-codes the other.
 */
(function () {
  'use strict';

  var BUY_BLOCKS = [
    '.section-variant-combo-grid',
    '.drinksilt-product-grid-section',
    '.drinksilt-pricing-section'
  ].join(',');

  /* The hero is not a buy block, but the bar must not sit over it either. Her
     call: it should not appear on the hero on any width, and coming back up to
     the hero it should go. The hero has its own CTA and its own switch; a
     second buy control over the top of them is the same mistake as covering a
     picker with a picker. */
  var HERO = '.section-silt-hero';

  var bar = document.querySelector('[data-silt-buybar]');
  if (!bar) return;

  var blocks = [].slice.call(document.querySelectorAll(BUY_BLOCKS));
  var heroes = [].slice.call(document.querySelectorAll(HERO));
  if (!blocks.length && !heroes.length) return;

  var onScreen = new WeakSet();
  var met = false;
  var shown = false;
  var raf = 0;

  /* The bar publishes two numbers and one flag, and the stylesheet does the
     rest. --silt-buybar-h lifts the docked toggle clear of the bar on a
     desktop; on a phone they share a row instead and the width is what the
     bar needs, because the pill is as wide as its three product names and
     nothing in CSS can measure that. */
  function publishHeight() {
    var root = document.documentElement;
    root.style.setProperty('--silt-buybar-h', shown ? Math.ceil(bar.getBoundingClientRect().height) + 'px' : '0px');
    root.classList.toggle('silt-buybar-in', shown);
    root.classList.toggle('silt-buybar-add', !!bar.querySelector('.silt-barbuy'));

    publishSwitchWidth();
  }

  /* The pill is narrower docked than it is in flow, because the docked rules
     tighten the buttons. Reading it once, when the bar appears, can catch it
     mid-change and reserve the wrong width, which leaves the control sitting
     under the toggle. So it is observed rather than sampled. */
  function publishSwitchWidth() {
    /* The phone mode chip grows upwards when open; measuring it then would
       move its own anchor and push it off the screen. Hold the last numbers. */
    if (document.querySelector('[data-silt-hero-switch].is-open')) return;
    var root = document.documentElement;
    var pill = document.querySelector('[data-silt-hero-switch] .drinksilt-theme-switch');

    /* Order matters. The control's width is published FIRST, because on a
       phone the stylesheet uses it to cap the toggle: 390 less the bar's two
       14s, less the 10 between them, less the control is what the toggle may
       have, and its three product names wrap to two lines inside that. Reading
       the toggle after setting this reflects the cap, because getBoundingClient
       Rect flushes style. Reading it before would publish the unclamped 273 and
       the control would sit under the toggle. */
    var cta = null;
    var ctas = bar.querySelectorAll('.silt-buybar__cta, .silt-barbuy');
    for (var j = 0; j < ctas.length; j++) {
      if (ctas[j].getBoundingClientRect().width > 0) { cta = ctas[j]; break; }
    }
    if (cta) root.style.setProperty('--silt-cta-w', Math.ceil(cta.getBoundingClientRect().width) + 'px');

    if (pill) {
      var w = Math.ceil(pill.getBoundingClientRect().width);
      if (w > 0) root.style.setProperty('--silt-switch-w', w + 'px');
      /* and its height, so the phone button can match it exactly (6 Oct) */
      var hgt = Math.round(pill.getBoundingClientRect().height);
      if (hgt > 0) root.style.setProperty('--silt-pill-h', hgt + 'px');
    }

    /* Where the slot landed. The row is centred and capped at 1280, so on a
       laptop its left edge is nowhere near the viewport's, and the toggle has
       to be told rather than compute it. Read after the width above, because
       the slot is sized from it. */
    var slots = document.querySelectorAll('.silt-buybar__switch-slot');
    for (var i = 0; i < slots.length; i++) {
      var box = slots[i].getBoundingClientRect();
      if (box.width > 0) {
        root.style.setProperty('--silt-switch-left', Math.round(box.left) + 'px');
        break;
      }
    }

    /* And how high. A fixed 10px off the bottom centres the toggle against the
       control on a phone, where both are 46 tall, and does not on a laptop,
       where the toggle is taller. So it is aligned to the control's own centre
       rather than to a number that happens to work at one width. */
    if (cta && pill) {
      var cb = cta.getBoundingClientRect();
      var pb = pill.getBoundingClientRect();
      if (cb.height > 0 && pb.height > 0) {
        /* ---- measured from the bar's padding, not from its position --------
           This read `window.innerHeight - cta.bottom`, and it is called the
           moment `is-in` lands, while the bar is still translated 110% down
           its own height. So the control's bottom was BELOW the viewport, the
           number came out negative, and the toggle was parked off the bottom
           of the screen: on a laptop she saw an empty slot and Buy now alone
           in the middle of the bar.

           Heights are not affected by a transform and neither is the bar's own
           padding, so the same answer comes out of those and it comes out the
           same whether the bar has finished sliding up or has not started. */
        var padBottom = parseFloat(getComputedStyle(bar).paddingBottom) || 0;
        var bottom = padBottom + (cb.height - pb.height) / 2;
        /* 3 Oct: with the price group the phone bar is two rows and the toggle
           sits on the upper one, so it centres on its own slot. Both rects
           carry the same transform, so the difference is settled either way. */
        var slotOn = null;
        for (var s2 = 0; s2 < slots.length; s2++) { if (slots[s2].getBoundingClientRect().width > 0) { slotOn = slots[s2]; break; } }
        if (slotOn) {
          var sb = slotOn.getBoundingClientRect(), bb = bar.getBoundingClientRect();
          bottom = (bb.bottom - sb.bottom) + (sb.height - pb.height) / 2;
        }
        root.style.setProperty('--silt-switch-bottom', Math.round(bottom) + 'px');
      }
    }
  }

  /* The toggle sits in the bar only once it has docked. Before that the slot
     would be an empty box, so it is collapsed until the pill is stuck. */
  var heroSwitch = document.querySelector('[data-silt-hero-switch]');
  function syncDocked() {
    var docked = !!(heroSwitch && heroSwitch.classList.contains('is-stuck'));
    if (document.documentElement.classList.contains('silt-switch-docked') === docked) return;
    document.documentElement.classList.toggle('silt-switch-docked', docked);
    if (shown) requestAnimationFrame(publishHeight);
  }
  if (heroSwitch) {
    new MutationObserver(syncDocked).observe(heroSwitch, { attributes: true, attributeFilter: ['class'] });
    syncDocked();
  }

  if ('ResizeObserver' in window) {
    var pillEl = document.querySelector('[data-silt-hero-switch] .drinksilt-theme-switch');
    if (pillEl) new ResizeObserver(publishSwitchWidth).observe(pillEl);
  }

  function show() {
    if (shown) return;
    shown = true;
    bar.hidden = false;
    /* One frame with the element laid out but still translated down, so the
       transition has a start value to animate from. Setting hidden=false and
       the class in the same frame skips the animation entirely. */
    requestAnimationFrame(function () {
      bar.classList.add('is-in');
      publishHeight();
    });

    /* Belt and braces: anything that depends on the bar's settled size is
       republished once it has actually settled. */
    bar.addEventListener('transitionend', publishHeight, { once: true });
  }

  function hide() {
    if (!shown) return;
    shown = false;
    bar.classList.remove('is-in');
    publishHeight();
  }

  /* The docked toggle leaves with the bar while a buy block is on screen.
     Scoped to .is-stuck so the toggle in the hero's own flow never goes.
     !important because the dock keyframes fill `both` and end on opacity 1,
     and only an important declaration outranks an animation. Kept here rather
     than in silt-system.css so the rule ships with the flag that drives it. */
  var awayStyle = document.createElement('style');
  awayStyle.textContent =
    'html.silt-buyblock-on [data-silt-hero-switch].is-stuck{' +
    'opacity:0!important;visibility:hidden!important;pointer-events:none!important;animation:none!important}';
  document.head.appendChild(awayStyle);

  function setToggleAway(away) {
    document.documentElement.classList.toggle('silt-buyblock-on', away);
  }

  function decide() {
    raf = 0;

    /* 6 Oct, her call: on a page with the hero, the bar is the one sticky
       element. It replaces the floating toggle, comes up the moment the hero
       has scrolled away, and stays through every section, pack pickers
       included, so price and Add to cart are always one tap away. It still
       goes back at the very top of the page. Pages without the hero keep the
       old rule below. */
    if (heroes.length) {
      /* 6 Oct, her later call: up from the first scroll, not once the hero
         has gone. Until the hero's own pill docks, the bar's toggle slot is
         collapsed (html.silt-switch-docked, below) so no empty box shows. */
      /* 7 Oct, her: only once the visitor has scrolled past half the hero
         (its middle has left the top of the screen). The hero docks its
         toggle on the same line, in silt-hero-film.liquid. */
      setToggleAway(false);
      var film = heroes[0].querySelector('[data-silt-hero]') || heroes[0];
      var hr = film.getBoundingClientRect();
      if (hr.top + hr.height / 2 < 0) show(); else hide();
      return;
    }

    /* A visible buy block wins over everything: the offer is already on
       screen and a bar over it would be the duplicate all over again. The
       hero counts the same way, and it keeps counting on the way back up. */
    /* The docked mode toggle goes with the bar over a buy block. Left behind,
       it floated alone over the cards' names (laptop) and the footer (phone).
       The cards carry their own pickers, so nothing is lost. 25 Sep audit. */
    var blockOn = false;
    for (var i = 0; i < blocks.length; i++) {
      if (onScreen.has(blocks[i])) { blockOn = true; break; }
    }
    setToggleAway(blockOn);
    if (blockOn) { hide(); return; }
    for (var k = 0; k < heroes.length; k++) {
      if (onScreen.has(heroes[k])) { hide(); return; }
    }

    /* Hidden sections are a real state here, not an edge case: on Combo the
       variant grid never renders, and on a phone in Mornings and Nights the
       pricing cards do not. A zero-height block has not been "met". */
    if (!met) {
      for (var j = 0; j < blocks.length; j++) {
        var box = blocks[j].getBoundingClientRect();
        if (box.height > 0 && box.bottom < 0) {
          met = true;
          break;
        }
      }
    }

    if (met) show();
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(decide);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) onScreen.add(entry.target);
      else onScreen.delete(entry.target);
    });
    schedule();
  }, { rootMargin: '0px 0px -10% 0px' });

  blocks.forEach(function (block) { io.observe(block); });

  /* The hero gets its own observer with no bottom margin, so the bar is gone
     the moment any part of the hero is on screen rather than a tenth of a
     viewport later. */
  var heroIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) onScreen.add(entry.target);
      else onScreen.delete(entry.target);
    });
    schedule();
  }, { rootMargin: '0px' });

  heroes.forEach(function (hero) { heroIo.observe(hero); });

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', function () { schedule(); publishHeight(); });

  /* The mode switch changes which line the bar shows, and the lines are not
     the same height in every mode. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (!event.target.closest('[data-drinksilt-theme-set]')) return;
    window.setTimeout(publishHeight, 320);
  });

  /* The cart drawer is the offer, in front of everything. */
  var drawer = document.querySelector('cart-drawer, .drawer');
  if (drawer) {
    new MutationObserver(function () {
      var open = drawer.classList.contains('active') || drawer.classList.contains('is-open');
      bar.style.visibility = open ? 'hidden' : '';
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  schedule();
})();
